var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import RcTabs, { TabPane, TabPaneProps } from 'rc-tabs';
import classNames from 'classnames';
import { CloseOutlined } from '@ant-design/icons';
import ControlAdd from '../_util/bonreeIcons/ControlAdd';
import devWarning from '../_util/devWarning';
import { ConfigContext } from '../config-provider';
import SizeContext from '../config-provider/SizeContext';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
import Popover from '../popover';
import MoreS from '../_util/bonreeIcons/MoreS';
export { TabPaneProps };
function Tabs(_a) {
    var { type, className, size: propSize, onEdit, hideAdd, centered, addIcon, popoverConfig } = _a, props = __rest(_a, ["type", "className", "size", "onEdit", "hideAdd", "centered", "addIcon", "popoverConfig"]);
    // locale
    const [globalLocale] = useLocaleReceiver('global');
    const isEN = /en/i.test((globalLocale === null || globalLocale === void 0 ? void 0 : globalLocale.locale) || '');
    const { prefixCls: customizePrefixCls, moreIcon = <MoreS /> } = props;
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('tabs', customizePrefixCls);
    const removePopoverPrefixCls = `${prefixCls}-tab-remove-popover`;
    const editRef = React.useRef(false);
    let editable;
    if (type === 'editable-card' || type === 'editable-line') {
        editable = {
            onEdit: (editType, { key, event }) => {
                if (editRef.current) {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit(key, 'edit');
                }
                else {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit(editType === 'add' ? event : key, editType);
                }
                editRef.current = false;
            },
            removeIcon: type === 'editable-line' ? (<Popover placement={(popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.placement) || 'bottomLeft'} overlayClassName={`${popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.overlayClassName} ${removePopoverPrefixCls}-overlay`} getPopupContainer={popoverConfig === null || popoverConfig === void 0 ? void 0 : popoverConfig.getPopupContainer} content={<div className={`${removePopoverPrefixCls}-content`}>
                <div className={`${removePopoverPrefixCls}-content-item`} onClick={() => {
                        editRef.current = true;
                    }}>
                  {globalLocale === null || globalLocale === void 0 ? void 0 : globalLocale.edit}
                </div>
                <div className={`${removePopoverPrefixCls}-content-item`}>{globalLocale === null || globalLocale === void 0 ? void 0 : globalLocale.del}</div>
              </div>}>
            <MoreS onClick={e => e.stopPropagation()}/>
          </Popover>) : (<CloseOutlined />),
            addIcon: addIcon || <ControlAdd />,
            showAdd: hideAdd !== true,
        };
    }
    const rootPrefixCls = getPrefixCls();
    if (process.env.NODE_ENV !== 'production')
        devWarning(!('onPrevClick' in props) && !('onNextClick' in props), 'Tabs', '`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead.');
    return (<SizeContext.Consumer>
      {contextSize => {
            const size = propSize !== undefined ? propSize : contextSize;
            return (<RcTabs direction={direction} moreTransitionName={`${rootPrefixCls}-slide-up`} {...props} className={classNames({
                    [`${prefixCls}-${size}`]: size,
                    [`${prefixCls}-card`]: ['card', 'editable-card'].includes(type),
                    [`${prefixCls}-editable-card`]: type === 'editable-card',
                    [`${prefixCls}-editable-line`]: type === 'editable-line',
                    [`${prefixCls}-centered`]: centered,
                    [`${prefixCls}-en`]: isEN,
                }, className)} editable={editable} moreIcon={moreIcon} prefixCls={prefixCls}/>);
        }}
    </SizeContext.Consumer>);
}
Tabs.TabPane = TabPane;
export default Tabs;
